import StudentOverviewPageActionTypes from './student-overview-page-action-types';
import axios from 'axios';
import { sortingToStringWithSubstitutes } from '../../../utils/objectUtils';

export const loadStudentOverviewPage = (studentId) => async(dispatch, getState, { api }) => {
  dispatch({ type: StudentOverviewPageActionTypes.LOAD_STUDENT_OVERVIEW_PAGE_START });
  const state = getState().studentOverviewPage;
  try {
    state.studentCancelToken?.cancel();
    state.studentCancelToken = axios.CancelToken.source();
    const [student, hoursSummary] = await Promise.all([
      api.get(`api/students/${studentId}`, null, state.studentCancelToken.token),
      api.get(`api/students/${studentId}/general_competency_hours/summary`, null, state.studentCancelToken.token).catch(() => null)
    ]);
    const mappedStudent = student
      ? { ...student, statusDate: student.statusDate ? new Date(student.statusDate) : null }
      : student;
    dispatch({
      type: StudentOverviewPageActionTypes.LOAD_STUDENT_OVERVIEW_PAGE_END,
      payload: { student: mappedStudent, hoursSummary }
    });
  } catch (error) {
    if (!(error instanceof axios.Cancel)) {
      dispatch({ type: StudentOverviewPageActionTypes.LOAD_STUDENT_OVERVIEW_PAGE_END });
      throw error;
    }
  }
};

export const selectStudentOverviewPageTab = (payload) => async(dispatch) => {
  dispatch({
    type: StudentOverviewPageActionTypes.SELECT_STUDENT_OVERVIEW_PAGE_TAB,
    payload: {
      selected: payload.selected
    }
  });
};

export const findStudentHours = (payload) => async(dispatch, getState, { api }) => {
  dispatch({ type: StudentOverviewPageActionTypes.LOAD_STUDENT_HOURS_START });
  const state = getState().studentOverviewPage;
  const query = {
    skip: payload.skip != null ? payload.skip : state.skip,
    limit: payload.take != null ? payload.take : state.take,
    sorting: sortingToStringWithSubstitutes(state.sorting, [
      { originalName: 'occurredAt', substituteName: 'OccurredAt' },
      { originalName: 'minutes', substituteName: 'Minutes' },
      { originalName: 'status', substituteName: 'Status' }
    ])
  };
  try {
    const result = await api.get(`api/students/${payload.studentId}/general_competency_hours`, query);
    dispatch({
      type: StudentOverviewPageActionTypes.LOAD_STUDENT_HOURS_END,
      payload: {
        hours: result ? result.data.map(h => ({
          ...h,
          occurredAt: h.occurredAt ? new Date(h.occurredAt) : null
        })) : [],
        total: result ? result.total : 0,
        skip: query.skip,
        take: query.limit
      }
    });
  } catch (error) {
    dispatch({ type: StudentOverviewPageActionTypes.LOAD_STUDENT_HOURS_END });
    throw error;
  }
};

export const sortStudentHours = (payload) => (dispatch) => {
  dispatch({
    type: StudentOverviewPageActionTypes.SORT_STUDENT_HOURS,
    payload: payload.sort
  });
  dispatch(findStudentHours({ studentId: payload.studentId }));
};
